export const calculateEasterSunday = (year) => {
    const a = year % 19;
    const b = Math.floor(year / 100);
    const c = year % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;

    return new Date(year, month - 1, day);
};

// eventueel ook exporteren wat je al had:
export const getEasterTiming = (birthDateString) => {
    if (!birthDateString) return null;

    const isoDateParts = typeof birthDateString === "string"
        ? birthDateString.match(/^(\d{4})-(\d{2})-(\d{2})/)
        : null;
    const parsedBirthDate = isoDateParts
        ? new Date(Number(isoDateParts[1]), Number(isoDateParts[2]) - 1, Number(isoDateParts[3]))
        : new Date(birthDateString);
    if (Number.isNaN(parsedBirthDate.getTime())) return null;
    const birthDate = new Date(
        parsedBirthDate.getFullYear(),
        parsedBirthDate.getMonth(),
        parsedBirthDate.getDate()
    );
    const easterDate = calculateEasterSunday(birthDate.getFullYear());

    if (birthDate < easterDate) return "before";
    if (birthDate > easterDate) return "after";
    return "on";
};

export const isBeforeOrAfterEaster = (birthDateString) => {
    const timing = getEasterTiming(birthDateString);
    if (timing === "before") return "🥚";
    if (timing === "after") return "🐣";
    if (timing === "on") return "🐰";
    return "Invalid Date";
};
